import Gallery from "../components/Gallery";

const GalleryPage = () => {
  document.title = "Галерея | Темные века";
  return <Gallery />;
};

export default GalleryPage;
